'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { useFlash } from "../../lib/FlashMessageProvider";

function getFlashType(status) {
  if (status >= 200 && status < 300) return "success";
  if (status === 400) return "warning";
  if (status === 401 || status === 403) return "error";
  if (status === 404) return "info";
  if (status >= 500) return "error";
  return "info";
}

export default function ForgetPassword() {
  const [form, setForm] = useState({ email: '' });
  const { addMessage } = useFlash();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('/api/forget', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: form.email }),
      });

      const flashType = getFlashType(response.status);
      let data = {};
      try {
        data = await response.json();
      } catch (e) {}

      if (!response.ok) {
        addMessage(flashType, data.data?.message || data.message || "Failed to send reset link");
        return;
      }
      console.log("Reset link:", data.data?.url);
      addMessage(flashType, data.data?.message || data.message || "Reset link sent!");
    } catch (error) {
      console.error("Network error:", error);
      addMessage("error", "Network error while sending reset link");
    }
  };

  return (
    <div className="w-100">
      <h3 className="mb-1">Forget Password</h3>
      <p className="text-muted">You can now reset your password. Please enter your email below.</p>

      <form onSubmit={handleSubmit}>
        <div className="col-12 form-group">
          <label htmlFor="email">User Email</label>
          <input
            type="email"
            name="email"
            className="custom-input"
            placeholder="Email"
            required
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn-submit mt-1 rounded-pill">
          Send Reset Link
        </button>

        <p className="auth-text mt-3">
          Already have an account? <Link href="/auth/login" className="text-danger">Login now</Link>
        </p>
      </form>

      <p className="auth-text mt-3">
        Still experiencing issues? <Link href="#" className="text-danger">Contact Support</Link>
      </p>
    </div>
  );
}